module.exports = require("./jgo.js");